import Modal, {ModalBody, ModalFooter, ModalHeader, ModalTitle} from "./Modal/Modal";

export const HasModalMixin = {
    components: {
        Modal,
        ModalHeader,
        ModalTitle,
        ModalFooter,
        ModalBody
    }
}
